module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.sidebarCurrentPanel === 'jump') ? _c('section', {
    staticClass: "kp-modular-submenu kp-modular-submenu-tab"
  }, [_c('div', {
    staticClass: "kp-modular-tab shadow-tab"
  }, [_c('header', {
    staticClass: "kp-modular-title"
  }, [_c('a', {
    staticClass: "klickart-element-back-button",
    attrs: {
      "href": "javascript:;",
      "title": _vm.$t('general.actions.back')
    },
    on: {
      "click": function($event) {
        return _vm.sidebarChangePanel('steps');
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  })]), _vm._v("\n      " + _vm._s(_vm.$t('general.labels.destinations')) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "submenu-content sub-color"
  }, [_c('ul', {
    staticClass: "submenu-no-padding scroll-person",
    attrs: {
      "id": "klickbox-step-list"
    }
  }, [_c('li', {
    staticClass: "kp-list-group-item"
  }, [_c('div', {
    staticClass: "kp-row"
  }, [_c('span', [_c('step-icon', {
    attrs: {
      "step": _vm.stepActive
    }
  }), _vm._v("\n              " + _vm._s(_vm.stepActive.sanitized_title) + "\n            ")], 1)])]), _vm._v(" "), _vm._l((_vm.jumpList), function(jump, index) {
    return _c('li', {
      staticClass: "submenu-padding"
    }, [_c('add-first-button'), _vm._v(" "), (jump.options_ids) ? _c('div', [_c('jump-header', {
      attrs: {
        "index": index,
        "jump-id": jump.id
      }
    }), _vm._v(" "), (_vm.stepActive.multiple_answers) ? _c('multiple-answer-select', {
      attrs: {
        "jump": jump
      }
    }) : _c('single-answer-select', {
      attrs: {
        "jump": jump
      }
    }), _vm._v(" "), _c('destiny-select', {
      attrs: {
        "selected": jump.destination_step_id,
        "jump": jump
      }
    })], 1) : _c('exception-select', {
      attrs: {
        "selected": jump.destination_step_id,
        "jump": jump
      }
    })], 1)
  })], 2)])])]) : _vm._e()
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-7d3a4de1!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/sidebar/steps/jump/Main.vue
 ** module id = 874
 ** module chunks = 1
 **/